import React, { useMemo } from "react";
import DropdownMenu from "../../theme/untitled/DropdownMenu/DropdownMenu";
import IconButton from "../../theme/untitled/IconButton/IconButton";
import Icon from "../../theme/untitled/icons/Icon";
import styles from "./MembersPage.module.scss";
import { ROLE_LABELS, ROLE_ORDER, ROLE_OWNER } from "./constants";

const RowActionsMenu = ({ row, isSoleOwner, onChangeRole, onOpenRemove, onResendInvite, onRevokeInvite, className }) => {
  const items = useMemo(() => {
    if (row.status === "pending") {
      return [
        { key: "resend", label: "Resend invitation", icon: <Icon name="RefreshCcw01" size={20} />, onClick: () => onResendInvite(row) },
        { key: "divider-1", type: "divider" },
        { key: "revoke", label: "Revoke invitation", icon: <Icon name="XClose" size={20} />, destructive: true, onClick: () => onRevokeInvite(row) },
      ];
    }

    const roleItems = ROLE_ORDER.map((roleValue) => ({
      key: `role-${roleValue}`,
      label: ROLE_LABELS[roleValue],
      disabled: isSoleOwner && roleValue !== ROLE_OWNER,
      icon:
        row.role === roleValue ? (
          <Icon name="Check" size={20} className={styles.menuCheck} />
        ) : (
          <span className={styles.menuCheckSpacer} aria-hidden="true" />
        ),
      onClick: () => onChangeRole(row, roleValue),
    }));

    // A non-owner row's "Transfer ownership" makes that row the new owner.
    // The sole owner's own row shows the same label but has no target to
    // transfer to from here — left unwired pending the open question in
    // FIXES2 (own confirmation dialog vs. plain role change).
    const transferItem =
      row.role === ROLE_OWNER
        ? isSoleOwner
          ? [{ key: "transfer", label: "Transfer ownership", icon: <Icon name="SwitchHorizontal01" size={20} /> }]
          : []
        : [
            {
              key: "transfer",
              label: "Transfer ownership",
              icon: <Icon name="SwitchHorizontal01" size={20} />,
              onClick: () => onChangeRole(row, ROLE_OWNER),
            },
          ];

    return [
      ...roleItems,
      { key: "divider-2", type: "divider" },
      ...transferItem,
      { key: "divider-3", type: "divider" },
      {
        key: "remove",
        label: "Remove from workspace",
        icon: <Icon name="Trash01" size={20} />,
        destructive: true,
        disabled: isSoleOwner,
        onClick: () => onOpenRemove(row),
      },
    ];
  }, [row, isSoleOwner, onChangeRole, onOpenRemove, onResendInvite, onRevokeInvite]);

  const trigger = (
    <IconButton
      size="md"
      variant="ghost"
      icon={<Icon name="DotsVertical" size={20} />}
      label="More options"
      className={className}
    />
  );

  const footer = isSoleOwner
    ? "A workspace needs one owner, and you are the only one. Transfer ownership first — then you can change your own role or leave."
    : undefined;

  return (
    <DropdownMenu trigger={trigger} items={items} align="end" panelClassName={styles.rowMenuPanel} footer={footer} />
  );
};

export default RowActionsMenu;
